import React from 'react';
// eslint-disable-next-line wandb/no-deprecated-imports
import {Icon} from 'semantic-ui-react';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

import {InstrumentedLoader} from '../../utility/InstrumentedLoader';

type RowExpandChildrenProps = {
  isExpanded: boolean;
  isGroup: boolean;
  isLoading: boolean;
  onToggleExpand?: () => void;
};

const StyledLoader = styled(InstrumentedLoader)`
  margin-left: -4px;
`;

export function RowExpandChildren({
  isExpanded,
  isGroup,
  isLoading,
  onToggleExpand,
}: RowExpandChildrenProps) {
  if (!isGroup) {
    return null;
  }

  if (isLoading) {
    return (
      <div style={{marginRight: -2, marginLeft: -4}}>
        <StyledLoader active inline name="is-group-loader" size="mini" />
      </div>
    );
  }
  return (
    <Icon
      role="button"
      aria-label={isExpanded ? 'Collapse group' : 'Expand group'}
      style={{marginRight: -2, marginLeft: -4}}
      className={`triangle ${isExpanded ? 'down' : 'right'}`}
      onClick={onToggleExpand}
    />
  );
}
